<template>
  <div class="irrigat">
    <div v-if="showdelis">
      <div class="searchpushmsg">
        <el-select
          @change="searchlist"
          filterable
          v-model="input"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          size="mini"
          type="warning"
          style="margin-left: 15px"
          @click="searchmsg()"
          >查询</el-button
        >
        <el-button
          :disabled="showbtn"
          size="mini"
          type="primary"
          style="margin-left: 15px"
          @click="newAdd()"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 100%;max-height: 528px;overflow-y: auto;"
      >
        <el-table-column prop="code" label="调水方案编码"></el-table-column>
        <el-table-column prop="createdBy" label="创建人"></el-table-column>
        <el-table-column prop="lastModifiedBy" label="修改人"></el-table-column>
        <!-- <el-table-column prop="annual" label="年度"></el-table-column> -->
        <!-- <el-table-column prop="date" label="时间"></el-table-column>
        <el-table-column prop="description" label="备注"></el-table-column>-->
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <div class="deal_box">
              <span
                class="deal_btn deal_btn_edit"
                style="color: #0082e5"
                @click="showdetails(scope.row)"
                >详情</span
              >
              <span
                class="deal_btn deal_btn_edit"
                style="color: #0082e5"
                @click="editAdd(scope.row)"
                >编辑</span
              >
              <span
                class="deal_btn deal_btn_del"
                :class="scope.row.id ? '' : 'gray'"
                @click="delTable(scope.row.id)"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        :close-on-click-modal="false"
        :title="titleshow"
        :visible.sync="dialogVisible"
        width="80%"
      >
        <projCodepush
          v-if="dialogVisible"
          :formlista="formLista"
          @closeDialog="closeDialog"
          :id="input"
        ></projCodepush>
      </el-dialog>
      <pagination
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        :page-sizes="[10, 20, 30, 40]"
        @pagination="getList"
      />
    </div>
    <div v-else>
      <showDelis
        @closeshowdelise="closeshowdelise"
        :id="delisid"
        :irrid="input"
      ></showDelis>
    </div>
  </div>
</template>

<script>
import {
  irrigatedget,
  irrigationplandel,
  irrigationplan,
} from "../../../api/irrigated";
import projCodepush from "./component/irrigatpush.vue";
import showDelis from "./component/showdelis.vue";

export default {
  name: "watermsg",
  data() {
    return {
      titleshow: "",
      showbtn: true,
      showdelis: true,
      delisid: "",
      page: 1,
      pageSize: 10,
      total: 10,
      input: "",
      ids: "111",
      tableData: [],
      tableData2: [],
      formLista: {},
      options2: [],
      dialogVisible: false,
    };
  },
  components: {
    projCodepush,
    showDelis,
  },
  created() {
    // this.getList();
  },
  mounted() {
    this.getList();
  },
  methods: {
    //获取灌区列表
    async getList() {
      let res = await irrigatedget();
      let data = res.body.data;
      data.forEach((item) => {
        this.options2.push({
          value: item.id,
          label: item.name,
        });
      });
    },
    //查询
    async searchlist() {
      let res = await irrigationplan({
        offset: this.page,
        limit: this.pageSize,
        id: this.input,
      });
      this.tableData = res.body.data;
      this.showbtn = false;
    },

    //删除取水口数据
    delTable(data) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          console.log(data);
          let res = await irrigationplandel(data, this.input);
          this.getList();
          this.$message.success("删除成功");
        })
        .catch(() => {
          this.$message.error("取消删除");
        });
    },
    searchmsg() {
      this.getList();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.getList();
    },
    cancelform() {
      this.$emit("closeDialog");
    },
    newAdd() {
      this.titleshow = "新增";
      this.titleshow = "新增";
      // this.title = "新增标段";
      this.dialogVisible = false;
      this.$nextTick(() => {
        this.formLista = {};
        this.dialogVisible = true;
      });
      this.formData = {
        projCode: this.bidding,
      };
    },
    //详情展示
    showdetails(row) {
      console.log(row);
      this.showdelis = false;
      this.delisid = row.id;
    },
    //关闭详情
    closeshowdelise() {
      this.showdelis = true;
    },
    //编辑
    editAdd(row) {
      this.titleshow = "编辑";
      this.titleshow = "编辑";
      this.formLista = row;
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.searchpushmsg {
  display: flex;
  justify-content: start;
}
.el-input {
  width: 200px;
}
.irrigat {
  padding: 5px;
  background-color: white;
  margin: 20px;
}
</style>
